document.addEventListener('DOMContentLoaded', function () {
  var header = document.querySelector('.mobile-facets__header');
  var panel = document.querySelector('.mobile-facets__inner');
  var closeBtn = document.querySelector('.mobile-facets__close');

  if (!header || !panel || !closeBtn) return;

  var startY = 0;
  var currentY = 0;
  var dragging = false;
  var CLOSE_THRESHOLD = 100;

  header.addEventListener('touchstart', function (e) {
    startY = e.touches[0].clientY;
    dragging = true;
    panel.style.setProperty('transition', 'none', 'important');
  }, { passive: true });

  header.addEventListener('touchmove', function (e) {
    if (!dragging) return;
    currentY = e.touches[0].clientY - startY;
    if (currentY < 0) currentY = 0;
    panel.style.setProperty('transform', 'translateY(' + currentY + 'px)', 'important');
  }, { passive: true });

  header.addEventListener('touchend', function () {
    if (!dragging) return;
    dragging = false;
    panel.style.removeProperty('transition');
    if (currentY > CLOSE_THRESHOLD) closeBtn.click();
    panel.style.removeProperty('transform');
    currentY = 0;
  });
});